import React from "react";
import useSWRMutation from 'swr/mutation';

const Tracking = ({ location }) => {
  const { trigger } = useSWRMutation('/inc');

  React.useEffect(() => {
    setTimeout(() => {
      trigger({
        category: 'page',
        name: location.pathname,
      }).catch(() => { });
    }, 1000);

  }, [location.pathname, trigger]);

  return null;
};

export default Tracking;